import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'

// Optional Font Awesome kit for Web Awesome Pro icon families (set in .env as VITE_FA_KIT_CODE).
const faKit = import.meta.env.VITE_FA_KIT_CODE as string | undefined
if (faKit && typeof document !== 'undefined') {
  document.documentElement.setAttribute('data-fa-kit-code', faKit)
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
